import React from 'react';
import {
  Button, Icon, ClickAwayListener, ListItem, ListItemText,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import {
  TextField, LoadingIndicator,
} from '..';

class ListSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      listOpen: false,
      selectedItem: null,
    };
  }

  filterByTerm = (item) => {
    const { searchValue } = this.state;
    const searchLowerCase = searchValue.toLowerCase();
    return String(item.name).toLowerCase().includes(searchLowerCase)
      || (item.secondaryName && String(item.secondaryName).toLowerCase().includes(searchLowerCase));
  }

  toggleOpen = (listOpen) => {
    const { children, toggleOpen } = this.props;
    return children ? toggleOpen(listOpen) : this.setState({ listOpen });
  }

  renderSearchBar() {
    const { searchValue } = this.state;
    const { hideSearch } = this.props;

    if (hideSearch) {
      return null;
    }

    return (
      <TextField
        autoFocus
        placeholder="Suche"
        classes={{ root: 'search-bar' }}
        value={searchValue || ''}
        onChange={e => this.setState({ searchValue: e.target.value })}
      />
    );
  }

  renderListItem = (item, style) => {
    const {
      selectedItems, onValueChanged, stayOpenOnSelect, isNew,
    } = this.props;
    const { selectedItem } = this.state;
    const isSelected = i => !isNew && (selectedItem === i.value || (selectedItems && !!(selectedItems.find(r => (r.value === i.value)))));
    return (
      <ListItem
        key={item.value}
        button
        onClick={() => {
          onValueChanged(item);
          if (!stayOpenOnSelect) {
            this.setState({ listOpen: false, selectedItem: item.value });
          }
        }}
        selected={isSelected(item)}
        value={item.value}
        className={isSelected(item) ? 'selected-item' : 'no-focus'}
        style={Number.isNaN(style) ? style : null}
      >
        <ListItemText classes={{ primary: 'primary' }} primary={item.name} secondary={item.secondaryName || null} />
      </ListItem>
    );
  }

  renderItems() {
    const { items } = this.props;
    const filteredItems = items.filter(this.filterByTerm);

    if (!filteredItems || !filteredItems.length) {
      return (
        <div className="no-entries">Keine Einträge vorhanden!</div>
      );
    }

    return (
      <div className="list-items">
        {filteredItems.map(this.renderListItem)}
      </div>
    );
  }

  renderList() {
    const { children, classes, isLoading } = this.props;
    const { listOpen } = children ? this.props : this.state;
    if (!listOpen) return null;

    return (
      <div className={`select-container ${classes.selectContainer}`}>
        {children || (
          <div>
            {isLoading && <div className="justify-center padding"><LoadingIndicator /></div>}
            {!isLoading && this.renderSearchBar()}
            {!isLoading && this.renderItems()}
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      itemName, itemType, classes, children, label, renderValue, selectedItems,
    } = this.props;
    const { listOpen } = children ? this.props : this.state;
    const icon = listOpen ? <Icon>arrow_drop_up</Icon> : <Icon>arrow_drop_down</Icon>;

    return (
      <ClickAwayListener onClickAway={() => this.toggleOpen(false)}>
        <div className={`list-selector ${listOpen ? 'open' : 'closed'} ${classes.outerContainer} `}>
          {label && <h3>{label}</h3>}
          <Button
            classes={{
              root: 'button-root',
              label: `button-label ${!itemName ? 'unselected' : ''}`,
            }}
            onClick={() => this.toggleOpen(!listOpen)}
          >
            {children ? renderValue(selectedItems) : (
              <span className="selected-list-item">{itemName || `${itemType} wählen`}</span>
            )}
            {icon}
          </Button>
          {this.renderList()}
        </div>
      </ClickAwayListener>
    );
  }
}

ListSelector.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.any,
  itemName: PropTypes.string,
  itemType: PropTypes.string,
  label: PropTypes.string,
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  listOpen: PropTypes.bool,
  stayOpenOnSelect: PropTypes.bool,
  isNew: PropTypes.bool,
  hideSearch: PropTypes.bool,
  toggleOpen: PropTypes.func,
  onValueChanged: PropTypes.func,
  renderValue: PropTypes.func,
};

ListSelector.defaultProps = {
  classes: {},
  children: '',
  itemName: null,
  itemType: '',
  label: '',
  isLoading: false,
  items: [],
  selectedItems: [],
  listOpen: false,
  stayOpenOnSelect: false,
  isNew: false,
  hideSearch: false,
  toggleOpen: () => {},
  onValueChanged: () => {},
  renderValue: () => {},
};

export default ListSelector;
